interface ResizeHandlePalette {
    colorBorder: string;
    colorTextQuaternary: string;
}

/**
 * Canonical resize affordance used by resizable platform surfaces.
 * The quiet ends blend into the surrounding border while the center remains
 * visible enough to communicate that the boundary can be dragged.
 */
export const getResizeHandleGradient = ({ colorBorder, colorTextQuaternary }: ResizeHandlePalette) =>
    `linear-gradient(180deg, ${colorBorder} 0%, color-mix(in srgb, ${colorTextQuaternary} 12%, ${colorBorder}) 8%, color-mix(in srgb, ${colorTextQuaternary} 36%, ${colorBorder}) 16%, color-mix(in srgb, ${colorTextQuaternary} 72%, ${colorBorder}) 24%, ${colorTextQuaternary} 32%, ${colorTextQuaternary} 68%, color-mix(in srgb, ${colorTextQuaternary} 72%, ${colorBorder}) 76%, color-mix(in srgb, ${colorTextQuaternary} 36%, ${colorBorder}) 84%, color-mix(in srgb, ${colorTextQuaternary} 12%, ${colorBorder}) 92%, ${colorBorder} 100%)`;

export const resizeHandleTransition = 'opacity 0.25s ease';
